var m = require('mithril');
var prop = require('mithril/stream');
var heading = require('../components/heading');
var header = require('../layout/components/header');
var usersOnlineMonitor = require('../layout/components/usersOnlineMonitor');
var loaders = require('../layout/components/loaders');
var io = require('../libs/socketio');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var dragscroll = require('../libs/dragscroll');
var moment = require('moment');
var alarmsTablePagination = require('../alarms/alarmsTablePagination');
var renderEventRow = require('../events/eventRow');

var component = {};

function getUserLabel(user) {
  if (!user) return '';
  var first = String(user.firstName || '').trim();
  var last = String(user.lastName || '').trim();
  var name = [first, last].filter(Boolean).join(' ');
  if (name) return name;
  return '';
}

function getObjectLabel(user) {
  if (!user) return '';
  var name = String(user.objectName || '').trim();
  if (name) return name;
  return '';
}

function getCurrentUrl(user) {
  if (!user) return '';
  return String(user.currentUrl || '').trim();
}

function getObjectPathNodes(user) {
  if (!user || !Array.isArray(user.objectPath)) return [];
  return user.objectPath;
}

function normalizeRid(value) {
  if (!value) return '';
  return String(value).replace(/^#/, '');
}

function formatPathNodeLabel(node) {
  if (!node) return '';
  var nodeClass = node.class || node['@class'] || '';
  var nodeName = node.name || '';
  if (nodeName === 'root') return 'Home';
  if (nodeClass === 'Room' && node.roomNumber) {
    return `${node.roomNumber} ${nodeName || ''}`.trim();
  }
  return nodeName || nodeClass || '';
}

function getPathNodeHref(node) {
  if (!node) return '';
  if (node.name === 'root') return '/location';
  var rid = normalizeRid(node.rid || node['@rid']);
  if (!rid) return '';
  var nodeClass = node.class || node['@class'] || '';
  if (nodeClass === 'Dashboard') return '/dashboard/' + rid;
  if (nodeClass === 'System') return '/system/' + rid;
  if (['Site', 'Building', 'Level', 'Room'].includes(nodeClass)) {
    return '/location/' + rid;
  }
  if (nodeClass) {
    return '/equipment/' + nodeClass.toLowerCase() + '/' + rid;
  }
  return '';
}

function buildPathNodesSignature(nodes) {
  return nodes.map(function (node) {
    return [
      node && (node.rid || node['@rid']) ? (node.rid || node['@rid']) : '',
      node && (node.class || node['@class']) ? (node.class || node['@class']) : '',
      node && node.name ? node.name : '',
      node && node.roomNumber ? node.roomNumber : ''
    ].join(':');
  }).join('|');
}

function toTimestamp(value) {
  if (value === null || typeof value === 'undefined') return -Infinity;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    var numeric = Number(value);
    if (!Number.isNaN(numeric)) return numeric;
    var parsedDate = Date.parse(value);
    return Number.isNaN(parsedDate) ? -Infinity : parsedDate;
  }
  var parsed = Date.parse(value);
  return Number.isNaN(parsed) ? -Infinity : parsed;
}

function buildSignature(list) {
  return list.map(function (user) {
    var parts = [
      user && user.userId ? user.userId : '',
      user && user.lastViewAt ? user.lastViewAt : '',
      user && user.currentUrl ? user.currentUrl : '',
      user && user.objectName ? user.objectName : '',
      buildPathNodesSignature(getObjectPathNodes(user))
    ];
    return parts.join('|');
  }).join('||');
}

function renderViewEventsHeader() {
  return m('tr', [
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Timestamp'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Event Type'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'User'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Description'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Object'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Path'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Value'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden.w-100', '')
  ]);
}

function shouldShowViewEventsTable(ctrl) {
  return !!(ctrl.showViewEventsOnOnlineUsers && ctrl.showViewEventsOnOnlineUsers())
    && !!(ctrl.showViewEvents && ctrl.showViewEvents());
}

function shouldShowActivityEventsTable(ctrl) {
  return true;
}

function syncUsers(ctrl) {
  var users = Array.isArray(usersOnlineMonitor.users) ? usersOnlineMonitor.users.slice() : [];
  users.sort(function (a, b) {
    var tsA = toTimestamp(a && a.lastViewAt);
    var tsB = toTimestamp(b && b.lastViewAt);
    if (tsA !== tsB) return tsB - tsA;
    return getUserLabel(a).localeCompare(getUserLabel(b));
  });
  var signature = buildSignature(users);
  if (signature === ctrl.usersSignature) return;
  ctrl.usersSignature = signature;
  ctrl.usersAll = users;
  ctrl.usersToShow.length = 0;
  ctrl.newNode(true);
}

component.oninit = function () {
  var ctrl = this;
  ctrl.usersAll = [];
  ctrl.usersToShow = [];
  ctrl.usersSignature = '';
  ctrl.newNode = prop(false);
  ctrl.showViewEvents = prop(true);
  ctrl.showViewEventsOnOnlineUsers = prop(true);
  ctrl.viewEventsRids = prop([]);
  ctrl.viewEventsRecords = prop([]);
  ctrl.viewEventsLoading = prop(false);
  ctrl.viewEventsSocketHandler = null;
  ctrl.viewEventsLocationRid = prop('users-online-view-events');
  ctrl.activityEventsRids = prop([]);
  ctrl.activityEventsRecords = prop([]);
  ctrl.activityEventsLoading = prop(false);
  ctrl.activityEventsSocketHandler = null;
  ctrl.activityCreateHandler = null;
  ctrl.activityEventsLocationRid = prop('users-online-activity-events');
  header.vm.activeTab('Users Online');
  document.title = 'nimrod | Users Online';

  ctrl.loadViewEvents = async function () {
    if (!shouldShowViewEventsTable(ctrl)) return;
    ctrl.viewEventsLoading(true);
    var end = moment();
    var start = moment(end).subtract(1, 'hour');
    try {
      var data = await loaders.requestWithLoader({
        url: '/api/v1/events/rids',
        method: 'GET',
        params: {
          start: start.valueOf(),
          end: end.valueOf(),
          type: 'ViewEvent',
          sort: 'desc',
          limit: 1000
        },
        background: true
      });
      var rids = Array.isArray(data) ? data.map(function (r) { return r['@rid']; }) : [];
      ctrl.viewEventsRids(rids);
      ctrl.viewEventsLocationRid(rids.length ? `users-online-view-events:${rids[0]}:${rids[rids.length - 1]}` : 'users-online-view-events');
      if (!rids.length) {
        ctrl.viewEventsRecords([]);
      }
    } catch (error) {
      console.error('Error loading view events for users online:', error);
      ctrl.viewEventsRids([]);
      ctrl.viewEventsRecords([]);
      ctrl.viewEventsLocationRid('users-online-view-events');
    } finally {
      ctrl.viewEventsLoading(false);
      m.redraw();
    }
  };

  ctrl.loadActivityEvents = async function () {
    if (!shouldShowActivityEventsTable(ctrl)) return;
    ctrl.activityEventsLoading(true);
    var end = moment();
    var start = moment(end).subtract(7, 'days');
    try {
      var data = await loaders.requestWithLoader({
        url: '/api/v1/events/rids',
        method: 'GET',
        params: {
          start: start.valueOf(),
          end: end.valueOf(),
          type: 'Comment,Command,Override',
          sort: 'desc',
          limit: 1000
        },
        background: true
      });
      var rids = Array.isArray(data) ? data.map(function (r) { return r['@rid']; }) : [];
      ctrl.activityEventsRids(rids);
      ctrl.activityEventsLocationRid(rids.length ? `users-online-activity-events:${rids[0]}:${rids[rids.length - 1]}` : 'users-online-activity-events');
      if (!rids.length) {
        ctrl.activityEventsRecords([]);
      }
    } catch (error) {
      console.error('Error loading comment/command events for users online:', error);
      ctrl.activityEventsRids([]);
      ctrl.activityEventsRecords([]);
      ctrl.activityEventsLocationRid('users-online-activity-events');
    } finally {
      ctrl.activityEventsLoading(false);
      m.redraw();
    }
  };

  ctrl.syncViewEventsSubscription = function () {
    if (shouldShowViewEventsTable(ctrl)) {
      if (!ctrl.viewEventsSocketHandler) {
        ctrl.viewEventsSocketHandler = function () {
          ctrl.loadViewEvents();
        };
        io.on('view-event', ctrl.viewEventsSocketHandler);
      }
      ctrl.loadViewEvents();
    } else if (ctrl.viewEventsSocketHandler) {
      io.off('view-event', ctrl.viewEventsSocketHandler);
      ctrl.viewEventsSocketHandler = null;
    }
  };

  ctrl.syncActivityEventsSubscription = function () {
    if (shouldShowActivityEventsTable(ctrl)) {
      if (!ctrl.activityEventsSocketHandler) {
        ctrl.activityEventsSocketHandler = function () {
          ctrl.loadActivityEvents();
        };
        io.on('comment-event', ctrl.activityEventsSocketHandler);
      }
      if (!ctrl.activityCreateHandler) {
        ctrl.activityCreateHandler = function (record) {
          if (!record || !record['@class']) return;
          if (record['@class'] === 'Comment' || record['@class'] === 'Command' || record['@class'] === 'Override') {
            ctrl.loadActivityEvents();
          }
        };
        io.on('create', ctrl.activityCreateHandler);
      }
      ctrl.loadActivityEvents();
    } else {
      if (ctrl.activityEventsSocketHandler) {
        io.off('comment-event', ctrl.activityEventsSocketHandler);
        ctrl.activityEventsSocketHandler = null;
      }
      if (ctrl.activityCreateHandler) {
        io.off('create', ctrl.activityCreateHandler);
        ctrl.activityCreateHandler = null;
      }
    }
  };

  ctrl.loadEventSettings = function () {
    return loaders.requestWithLoader({
      url: '/api/v1/events/settings',
      method: 'GET',
      background: true
    })
    .then(function (res) {
      if (!res || typeof res !== 'object') return;
      ctrl.showViewEvents(!!res.showViewEvents);
      ctrl.showViewEventsOnOnlineUsers(!!res.showViewEventsOnOnlineUsers);
    })
    .catch(function (error) {
      console.error('Failed to load event settings for users online:', error);
    })
    .finally(function () {
      ctrl.syncViewEventsSubscription();
      ctrl.syncActivityEventsSubscription();
      m.redraw();
    });
  };

  syncUsers(ctrl);
  usersOnlineMonitor.requestUsers()
    .then(function () {
      syncUsers(ctrl);
      m.redraw();
    });
  ctrl.loadEventSettings();
};

component.onbeforeupdate = function () {
  syncUsers(this);
  return true;
};

component.onremove = function () {
  if (this.viewEventsSocketHandler) {
    io.off('view-event', this.viewEventsSocketHandler);
    this.viewEventsSocketHandler = null;
  }
  if (this.activityEventsSocketHandler) {
    io.off('comment-event', this.activityEventsSocketHandler);
    this.activityEventsSocketHandler = null;
  }
  if (this.activityCreateHandler) {
    io.off('create', this.activityCreateHandler);
    this.activityCreateHandler = null;
  }
};

component.view = function () {
  var ctrl = this;
  var usersToShow = Array.isArray(ctrl.usersToShow) ? ctrl.usersToShow : [];
  var hasUsers = Array.isArray(ctrl.usersAll) && ctrl.usersAll.length > 0;
  var minimumRows = 10;
  var paddedUsersToShow = usersToShow.slice(0);
  while (paddedUsersToShow.length < minimumRows) {
    paddedUsersToShow.push({});
  }
  var showViewEventsTable = shouldShowViewEventsTable(ctrl);
  var viewEventsRids = Array.isArray(ctrl.viewEventsRids()) ? ctrl.viewEventsRids() : [];
  var viewEventsRecords = Array.isArray(ctrl.viewEventsRecords()) ? ctrl.viewEventsRecords() : [];
  var viewEventsLoading = ctrl.viewEventsLoading();
  var viewEventsLocationRid = ctrl.viewEventsLocationRid();
  var showActivityEventsTable = shouldShowActivityEventsTable(ctrl);
  var activityEventsRids = Array.isArray(ctrl.activityEventsRids()) ? ctrl.activityEventsRids() : [];
  var activityEventsRecords = Array.isArray(ctrl.activityEventsRecords()) ? ctrl.activityEventsRecords() : [];
  var activityEventsLoading = ctrl.activityEventsLoading();
  var activityEventsLocationRid = ctrl.activityEventsLocationRid();

  return m('div.mh3', [
    m(heading, {
      label: 'Online Users',
      class: 'f-subheadline mb3 pb1 display items-center'
    }),
    hasUsers ? m(paginationWithSearch, {
      data: ctrl.usersAll,
      newNode: ctrl.newNode,
      dataToShow: ctrl.usersToShow,
      placeHolder: 'Search users online',
      itemsPerPage: 10,
      fieldsToSearch: ['firstName', 'lastName', 'email', 'currentUrl', 'objectName']
    }, [
      m('div.overflow-hidden', [
        m('div.dragscroll-container', [
          m('div.dragscroll', { oncreate: dragscroll }, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              m('colgroup', [
                m('col', { width: '20%' }),
                m('col', { width: '25%' }),
                m('col', { width: '15%' }),
                m('col', { width: '40%' })
              ]),
              m('thead', [
                m('tr', [
                  m('th.ph0.pv1.tl', 'User'),
                  m('th.ph0.pv1.tl', 'Current Url'),
                  m('th.ph0.pv1.tl', 'Object'),
                  m('th.ph0.pv1.tl', 'Object Path')
                ])
              ]),
              m('tbody', [
                paddedUsersToShow.map(function (user) {
                  var isPlaceholder = !user || Object.keys(user).length === 0;
                  var blankCell = '\u00A0';
                  return m('tr', [
                    m('td.tl.nowrap.pv1', isPlaceholder ? blankCell : getUserLabel(user)),
                    m('td.tl.nowrap.pv1', (function () {
                      if (isPlaceholder) return blankCell;
                      var url = getCurrentUrl(user);
                      if (!url) return '';
                      return m(m.route.Link, { class: 'blue dim', href: url }, url);
                    })()),
                    m('td.tl.nowrap.pv1', isPlaceholder ? blankCell : getObjectLabel(user)),
                    m('td.tl.pv1', (function () {
                      if (isPlaceholder) return blankCell;
                      var nodes = getObjectPathNodes(user);
                      if (!nodes.length) return '';
                      var displayNodes = nodes.map(function (node) {
                        var label = formatPathNodeLabel(node);
                        if (!label) return null;
                        return {
                          label: label,
                          href: getPathNodeHref(node)
                        };
                      }).filter(Boolean);
                      if (!displayNodes.length) return '';
                      return m('span.nowrap', displayNodes.map(function (node, idx) {
                        var content = node.href
                          ? m(m.route.Link, { class: 'blue dim', href: node.href }, node.label)
                          : node.label;
                        return m('span', [
                          content,
                          idx < displayNodes.length - 1 ? ' / ' : ''
                        ]);
                      }));
                    })())
                  ]);
                })
              ])
            ])
          ])
        ])
      ])
    ]) : m('div.f4.gray', 'No users online.'),
    showViewEventsTable ? m('div.mt4', [
      m('div.flex.items-center.justify-between.flex-wrap.f2', [
        m('div.flex.items-center.overflow-hidden', [
          m('div', 'View Events (Last Hour)')
        ]),
        m('div.flex.items-center.flex-wrap', [
          m('label.mr2.f5.moon-gray', 'Total:'),
          m('div.br2.nowrap.mr2', { style: { 'background-color': '#262626' } }, [
            m('label.f4.ph1', `${viewEventsLoading ? '—' : (viewEventsRids.length || 0)}`)
          ])
        ])
      ]),
      viewEventsRids.length || viewEventsLoading
        ? m('div.mt2', [
          m('div.overflow-hidden.mb3', [
            m('div.dragscroll-container', [
              m('div.dragscroll', { oncreate: dragscroll }, [
                m('table.f4.pb3.narrow.w-100.mr3', [
                  m('tbody', [
                    renderViewEventsHeader(),
                    viewEventsRecords.map(function (record) {
                      return renderEventRow(record);
                    })
                  ])
                ])
              ])
            ])
          ]),
          viewEventsRids.length
            ? m(alarmsTablePagination, {
              data: [...viewEventsRids],
              url: '/api/v1/events/paginated',
              recordsToShow: ctrl.viewEventsRecords,
              location: { '@rid': viewEventsLocationRid },
              numberOfColumns: 10
            })
            : m('div', { style: { 'min-height': '56px' } })
        ])
        : m('div.f4.gray.mt2', 'No view events.')
    ]) : null,
    showActivityEventsTable ? m('div.mt4', [
      m('div.flex.items-center.justify-between.flex-wrap.f2', [
        m('div.flex.items-center.overflow-hidden', [
          m('div', 'Commands & Comments')
        ]),
        m('div.flex.items-center.flex-wrap', [
          m('label.mr2.f5.moon-gray', 'Total:'),
          m('div.br2.nowrap.mr2', { style: { 'background-color': '#262626' } }, [
            m('label.f4.ph1', `${activityEventsLoading ? '—' : (activityEventsRids.length || 0)}`)
          ])
        ])
      ]),
      activityEventsRids.length || activityEventsLoading
        ? m('div.mt2', [
          m('div.overflow-hidden.mb3', [
            m('div.dragscroll-container', [
              m('div.dragscroll', { oncreate: dragscroll }, [
                m('table.f4.pb3.narrow.w-100.mr3', [
                  m('tbody', [
                    renderViewEventsHeader(),
                    activityEventsRecords.map(function (record) {
                      return renderEventRow(record);
                    })
                  ])
                ])
              ])
            ])
          ]),
          activityEventsRids.length
            ? m(alarmsTablePagination, {
              data: [...activityEventsRids],
              url: '/api/v1/events/paginated',
              recordsToShow: ctrl.activityEventsRecords,
              location: { '@rid': activityEventsLocationRid },
              numberOfColumns: 10
            })
            : m('div', { style: { 'min-height': '56px' } })
        ])
        : m('div.f4.gray.mt2', 'No comment/command events.')
    ]) : null
  ]);
};

module.exports = component;
